// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2QZiC","title":"Info_title__1tRF_","links":"Info_links__1cpkC","link":"Info_link__1wKh2","logo":"Info_logo__1r8d0"};